import {isProduction} from "../../../../../hooks/useEnvironment";

export function isCentinelMessageOriginAllowed(origin) {
    const url = new URL(origin);

    return url.hostname.endsWith('.cardinalcommerce.com')
}

export function isOntMessageOriginAllowed(origin) {
    const url = new URL(origin);

    return url.protocol === "https:"
        && (
            url.hostname.endsWith('.nanoporetech.com')
            || url.hostname.endsWith('.test')
        );
}
